import axios from "axios";
import { useDrupalSettings } from "../../composables/useDrupalSettings.js";

const { config } = useDrupalSettings();

const state = {
  observationTypes: [],
  selObvTypes: [],
  obvHazardTypes: [],
  selHazardTypes: [],
  observationConfig: {},
  obvHistoryDateBefore: "",
  obvHistoryDateAfter: "",
  obvLocationSpecifics: "",
  obvAnonSubmission: false,
  obvDescription: "",
  obvHazardOther: "",
  obvImageFileIds: [],
  obvImageFiles: [],
};

const mutations = {
  setObservationConfig: (state, newConfig) =>
    (state.observationConfig = newConfig),
  setObvHistoryDateBefore: (state, date) => (state.obvHistoryDateBefore = date),
  setObvHistoryDateAfter: (state, date) => (state.obvHistoryDateAfter = date),
  setSelHazardTypes: (state, hazards) => (state.selHazardTypes = hazards),
  setObvHazardOther: (state, hazOther) => (state.obvHazardOther = hazOther),
  setSelObvTypes: (state, observationType) =>
    (state.selObvTypes = observationType),
  setObvLocationSpecifics: (state, string) =>
    (state.obvLocationSpecifics = string),
  setObvHazardTypes: (state, types) => (state.obvHazardTypes = types),
  setObservationTypes: (state, types) => (state.observationTypes = types),
  setObvAnonSubmissions: (state, isAnon) => (state.obvAnonSubmission = isAnon),
  setObvDescription: (state, desc) => (state.obvDescription = desc),
  setObvImageFileIds: (state, fileIds) => (state.obvImageFileIds = fileIds),
  setObvImageFiles: (state, files) => (state.obvImageFiles = files),
};
const getters = {
  getObservationTypes: (state) => state.observationTypes,
  getObvHistoryDateBefore: (state) => state.obvHistoryDateBefore,
  getObvHistoryDateAfter: (state) => state.obvHistoryDateAfter,
  getObvLocationSpecifics: (state) => state.obvLocationSpecifics,
  getObvHazardTypes: (state) => state.obvHazardTypes,
  getObvAnonSubmission: (state) => state.obvAnonSubmission,
  getSelHazardTypes: (state) => state.selHazardTypes,
  getSelObvTypes: (state) => state.selObvTypes,
  getObvDescription: (state) => state.obvDescription,
  getObvHazardOther: (state) => state.obvHazardOther,
  getObservationConfig: (state) => state.observationConfig,
  getObvImageFiles: (state) => state.obvImageFiles,
};

const actions = {
  fetchSafetyObservationConfig({ commit, rootState }) {
    return axios
      .get(
        rootState.config.restUrl +
          "/safety_observations_config" +
          "?_format=json",
        {
          headers: {
            "Content-Type": "application/vnd.api+json",
            Authorization: "Bearer " + rootState.config.jwt,
            crossDomain: true,
          },
        },
      )
      .then((response) => {
        // handle success
        commit("setObservationConfig", response.data);
        if (
          response.data.hasOwnProperty(
            "node.safety_observation.field_so_type_of_observation",
          )
        ) {
          const obvType =
            response.data[
              "node.safety_observation.field_so_type_of_observation"
            ].options;
          const obvTypes = Object.keys(obvType).map((key) => ({
            key: key,
            title: obvType[key],
          }));
          const hzdType =
            response.data["node.safety_observation.field_so_type_of_hazard"]
              .options;
          const hzdTypes = Object.keys(hzdType).map((key) => ({
            key: key,
            title: hzdType[key],
          }));
          commit("setObservationTypes", obvTypes);
          commit("setObvHazardTypes", hzdTypes);
        }
      });
  },
  createSafetyObservation({ state, rootState }) {
    const observationData = {};
    if (rootState?.FilterStore?.selectedBuildings?.length) {
      observationData.field_so_building = [
        { target_uuid: rootState?.FilterStore?.selectedBuildings?.[0]?.uuid },
      ];
    }

    if (rootState?.FilterStore?.selectedSpaces?.length) {
      observationData.field_so_space = [
        { target_uuid: rootState.FilterStore.selectedSpaces },
      ];
    }
    observationData.field_so_photos = [];
    for (let i = 0; i < state.obvImageFileIds.length; ++i) {
      observationData.field_so_photos.push({
        target_uuid: state.obvImageFileIds[i],
      });
    }

    if (state.obvDescription) {
      observationData.field_so_describe = [{ value: state.obvDescription }];
    }
    if (state.obvAnonSubmission) {
      observationData.field_so_anon_submission = [
        { value: state.obvAnonSubmission },
      ];
    }
    if (state.obvLocationSpecifics) {
      observationData.field_so_location_specifics = [
        { value: state.obvLocationSpecifics },
      ];
    }

    if (state.selHazardTypes.length) {
      observationData.field_so_type_of_hazard = [
        { value: state.selHazardTypes },
      ];
    }
    if (state.obvHazardOther) {
      observationData.field_so_type_of_hazard_other = [
        { value: state.obvHazardOther },
      ];
    }

    observationData.field_so_type_of_observation = [
      { value: state.selObvTypes },
    ];
    observationData.type = [{ target_id: "safety_observation" }];
    observationData.title = [{ value: "safety_observation" }];

    const url = rootState.config.baseUrl + "/node?_format=json";
    // @todo refactor this to a helper.
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + rootState.config.jwt,
      crossDomain: true,
      "X-CSRF-Token": config.csrfToken,
    };
    axios.post(url, observationData, { headers: headers }).then((response) => {
      // Check response data.
      if (response.data.hasOwnProperty("nid")) {
        if (!rootState.config.isB4) {
          window.location.href =
            "/submit/raft_safety_observation/" + response.data.nid[0].value;
        } else {
          window.location.href = "/submit/raft_safety_observation";
        }
      }
    });
  },
  updateObvAnonSubmission({ commit }, value) {
    commit("setObvAnonSubmissions", value);
  },
  updateSelectedHazards({ commit }, value) {
    commit("setSelHazardTypes", value);
  },
  updateObvHazardOther({ commit }, value) {
    commit("setObvHazardOther", value);
  },
  updateObservationDateBefore({ commit }, value) {
    commit("setObvHistoryDateBefore", value);
  },
  updateObservationDateAfter({ commit }, value) {
    commit("setObvHistoryDateAfter", value);
  },
  updateSelectedObservationType({ commit }, value) {
    commit("setSelObvTypes", value);
  },
  updateObvDescription({ commit }, value) {
    commit("setObvDescription", value);
  },
  updateObvImageFiles({ commit }, value) {
    commit("setObvImageFiles", value);
  },
  clearObvSelectedFilters({ commit }, value) {
    commit("setObvImageFiles", []);
    commit("setSelHazardTypes", []);
    commit("setSelObvTypes", []);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
